<template>
    <div class="accent-panel" :class="{ 'accent-panel--image': showImage }">
        <slot />
    </div>
</template>

<script>

export default {
    props: {
        showImage: {
            type: Boolean,
            default: false,
        },
    },
}

</script>

<style lang="scss">

$background-image-height: 11rem;

.accent-panel {
    @include bp-min-mid {
        padding: 1.2rem;
        margin-bottom: 1.2rem;
    }

    @include modifier('image') {
        @include bp-min-mid {
            padding-top: ($background-image-height + 1rem) !important;
            background: url('~@/assets/survey.jpg') top center no-repeat;
            background-size: auto $background-image-height;
        }
    }
}

</style>
